// Die zwei Ringe des Hauptscreens: "Punkte" (Stern, gold) und "Fortschritt"
// (Flagge, gruen). SVG-Kreis mit Bogenmass statt eines fertigen
// Diagramm-Pakets, dafuer ist das hier zu klein.

import type { ReactNode } from "react";

const RADIUS = 34;
const UMFANG = 2 * Math.PI * RADIUS;

export function Ring({
  anteil,
  vollton,
  track,
  icon,
  oben,
  unten,
}: {
  /** 0 bis 1. */
  anteil: number;
  vollton: string;
  track: string;
  icon: ReactNode;
  oben: string;
  unten: string;
}) {
  const versatz = UMFANG * (1 - Math.min(1, Math.max(0, anteil)));

  return (
    // Ring links, Zahl+Label rechts daneben (nicht darunter): per Pipette
    // aus IMG_4893 - dort steht "7611 / Punkte" als Textblock neben dem
    // Ring, nicht zentriert darunter. Ring-Durchmesser dort gemessen
    // ~52px bei 393px Bildschirmbreite, deutlich kleiner als zuvor.
    <div className="flex items-center gap-3">
      <div className="relative flex h-[52px] w-[52px] shrink-0 items-center justify-center">
        <svg viewBox="0 0 80 80" className="absolute inset-0 -rotate-90">
          <circle cx="40" cy="40" r={RADIUS} fill="none" stroke={track} strokeWidth="6" />
          <circle
            cx="40"
            cy="40"
            r={RADIUS}
            fill="none"
            stroke={vollton}
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={UMFANG}
            strokeDashoffset={versatz}
          />
        </svg>
        {icon}
      </div>
      <div>
        <div className="text-lg font-semibold leading-tight">{oben}</div>
        <div className="text-xs text-neutral-500">{unten}</div>
      </div>
    </div>
  );
}
